import { render, staticRenderFns } from "./infoList.vue?vue&type=template&id=fb2e9486&scoped=true&lang=html&"
import script from "./infoList.vue?vue&type=script&lang=js&"
export * from "./infoList.vue?vue&type=script&lang=js&"
import style0 from "./infoList.vue?vue&type=style&index=0&id=fb2e9486&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb2e9486",
  null
  
)

export default component.exports